require("./src/styles/global.scss")

exports.shouldUpdateScroll = () => {
    return false
}
